import { redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";

import { getAuthedPlayerSession } from "#/server/authedSession.server";

export const requireProfileAuth = createServerFn({ method: "GET" }).handler(async () => {
  const session = await getAuthedPlayerSession();
  if (!session) {
    throw redirect({ to: "/" });
  }
  return { userId: session.userId };
});
